// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"2845cc0a","990":"28f1568a"}[chunkId] + ".chunk.js";
};